// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "@/assets/font/font.css";
import VueParticles from 'vue-particles'
import animate from 'animate.css'
import Print from 'vue-print-nb'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


//main.js中
import './utils/flexible' 

import axios from 'axios';

Vue.use(animate)

Vue.use(Print)

Vue.use(VueParticles)

Vue.use(ElementUI)

// 判断当前是什么语言 zh-CN en-US
let language = sessionStorage.getItem('language')
if (language) {
  Vue.prototype.$language = language
} else {
  Vue.prototype.$language = 'zh'
  sessionStorage.setItem('language', 'zh')
}

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js